import { matchPath, useLocation } from 'react-router-dom';
import { PagePath } from '@/routes/paths';
import useRequestsStore from '@/stores/request-session';
import { usePushMessage, PushEventType } from '@/hooks/useWebSocket';
import { readPost } from '@/services/swagger/easourcing/SessionService';

export interface NewMessagePayload {
  sessionId: string;
  totalUnreadNum: number;
  unreadNum: number;
}

interface TaskRunningPayload {
  sessionId: string;
  inquiryTaskRunning: 0 | 1;
}

export function useRequestsUpdate() {
  const { updateTotalUnreadCount, updateUnreadStatusMap, moveSessionToTop, updateSessionItem, loadUnreadStatus } =
    useRequestsStore();
  const location = useLocation();
  const matchRouter = matchPath(PagePath.chat, location.pathname);

  usePushMessage<NewMessagePayload>(PushEventType.SESSION_NEW_MSG, payload => {
    const content = payload.content || {};
    if (!content?.sessionId) return;
    // 当前会话正在被查看
    if (matchRouter?.params?.sessionId === content.sessionId) {
      // 先标已读 然后刷新菜单上的未读状态(包含总数)
      readPost({ sessionId: content.sessionId }).then(() => {
        loadUnreadStatus([content.sessionId], true);
      });
      return;
    }

    // 更新未读数， 并且把会话移到队列顶部
    if (content.sessionId) {
      updateTotalUnreadCount(content.totalUnreadNum || 0);
      updateUnreadStatusMap(content.sessionId, content.unreadNum || 0);
      moveSessionToTop(content.sessionId);
    }
  });

  usePushMessage<TaskRunningPayload>(PushEventType.SESSION_TASK_RUNNING, payload => {
    const content = payload.content || {};
    if (!content?.sessionId) return;
    updateSessionItem(content.sessionId, { inquiryTaskRunning: content.inquiryTaskRunning });
  });
}
